<template>
    <div
        tabindex="0"
        :class="
            `
        action 
        ${name} 
        ${selected ? 'selected' : ''} 
        ${small ? 'small' : ''}
        ${disabled ? 'disabled' : ''} 
        `
        "
        @click="$emit('click')"
        @keyup.enter="$emit('click')"
    >
        <v-icon
            class="icon"
            :color="colorIcon"
            v-if="withIcon"
            :class="loadingIcon ? 'hide-icon' : ''"
            >{{ withIcon }}</v-icon
        >
        <v-progress-circular
            v-if="loadingIcon"
            class="loading-icon"
            :color="colorIcon"
            :size="12"
            :width="2"
            :indeterminate="true"
        />
        <typo :name="small ? 'body-12-normal' : 'body-16-medium'" data-hj-suppress>
            <slot></slot>
        </typo>
        <chevron v-if="!nochevron" />
    </div>
</template>

<script>
import Vue from "vue";

import Chevron from "../icons/Chevron.vue";

export default Vue.extend({
    components: {
        Chevron,
    },
    props: [
        "name",
        "disabled",
        "nochevron",
        "selected",
        "small",
        "withIcon",
        "colorIcon",
        "loadingIcon",
    ],
});
</script>

<style lang="sass" scoped>
.action
    display: flex
    align-items: center
    cursor: pointer
    position: relative

.disabled
    pointer-events: none
    .typo
        opacity: .5

// Mode 1
.main
    border: 1px solid $color-main
    padding: 0 12px
    height: 40px
    transition: background .15s ease
    .typo
        color: $color-main
    .chevron
        fill: $color-main
        margin-left: 10px
    &:hover
        background: $color-main
        .typo
            color: white
        .chevron
            fill: white
@media print
    .main
        .chevron
            display: none
// Mode 2
.light
    background: white
    padding: 0 12px
    height: 40px
    transition: background .15s ease
    .typo
        color: $color-text
    .chevron
        fill: $color-text
        margin-left: 10px
    &:hover
        background: $color-secondary
        .typo
            color: white
        .chevron
            fill: white

// Mode 3
.light-outlined
    border: 1px solid white
    padding: 0 12px
    height: 40px
    transition: background .15s ease
    .typo
        color: white
    .chevron
        fill: white
        margin-left: 10px
    &:hover
        background: white
        .typo
            color: $color-secondary
        .chevron
            fill: $color-secondary
    &.selected
        background: white
        pointer-events: none
        .typo
            color: $color-secondary
        .chevron
            fill: $color-secondary

// Mode 5
.submit
    background: white
    height: 48px
    display: flex
    align-items: center
    justify-content: center
    transition: background .15s ease
    &:hover
        background: $color-secondary
        color: white
        border: 1px solid white

    +r(480)
        height: 40px

.submit-dark
    @extend .submit
    background: $color-main
    color: white
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%)
    &:hover
        border: none
    .v-icon
        color: white
        caret-color: white

@media print
    .main
        .chevron
            display: none

.link .typo
    color: $color-main
    &:hover
        text-decoration: underline

.link-light
    .typo
        color: $color-white
        &:hover
            text-decoration: underline
    .icon
        color: $color-white

.small
    height: 30px

.light-border
    border: 1px solid $color-text
    padding: 0 12px
    height: 40px
    transition: background .15s ease
    .typo
        color: $color-text
    .chevron
        fill: $color-text
        margin-left: 10px
    &:hover
        background: $color-text
        .typo
            color: white
        .chevron
            fill: white

// Mode 6 account-notification-convention-action
.account-convention-notification-action
    background: transparent
    padding: 0 12px
    height: 40px
    transition: background .15s ease
    .typo
        color: $color-text
    .chevron
        fill: $color-text
        margin-left: 10px
    &:hover
        .typo
            color: $color-main
        .chevron
            fill: $color-main

// Icons

.chevron
    margin-left: 10px

.icon
    margin-right: 5px

.hide-icon
    opacity: 0

.loading-icon
    position: absolute
    left: 11px
    top: 7px
</style>
